import { loadStripe } from "@stripe/stripe-js";

const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let _promise = null;
export const getStripe = () => {
  if (!key) {
    console.warn(
      "REACT_APP_STRIPE_PUBLISHABLE_KEY not set — Stripe features disabled.",
    );
    return null;
  }
  if (!_promise) _promise = loadStripe(key);
  return _promise;
};
